<template>
  <div class="customer-stage">
    <div class="content">
      <div class="top-content">
        <el-row>
          <el-col :span="24"><div class="grid-content-one">
            <h4 style="padding-left: 29px">未知等级</h4>
            <div class="tip-content">该等级为特殊等级不支持改名。客户数据被记录到系统，<strong style="color: #1890FF">但是没有任何互动记录和客户事件信息</strong>，所以无法判断等级。应该尽最大可能避免处于该等级的客户记录。</div>
            <div class="grid-content-text tip-content">
              <label>默认情况下，以下情况的客户记录会处于未知等级</label>
              <ul>
                <li><i></i>人工创建的客户记录</li>
                <li><i></i>通过文件批量导入的客户记录（强烈建议在客户导入的时候指定其他合适的等级）</li>
                <li><i></i>通过系统集成的方式从外部第三方系统导入的客户记录（强烈建议在集成过程中指定合适的等级）</li>
              </ul>
            </div>
          </div>
          </el-col>
        </el-row>
      </div>
      <div class="bottom-content">
        <!--<h4><img src="../../assets/images/stage-other.png" />其他等级</h4>-->
        <el-row :key="index" v-for="(item, index) in stages" class="item">
          <el-col :span="24">
            <div class="stage-input">
              <el-input id="input" :disabled="item.hide === true" v-model="item.name" placeholder="请输入内容"></el-input>
              <img id="edit" src="../../assets/images/icn-binaji.png" title="编辑" v-if="item.hide === true" @click="initialContactClick(item)" class="edit-btn">
              <i title="取消" v-if="item.hide === false" @click="cancel(item)" class="save-btn" style="margin-left: 37px">取消</i>
              <i title="保存" v-if="item.hide === false" @click="confirmEdit(item)" class="save-btn" style="margin-left: 10px">保存</i>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import { editCustomerStage, getCustomerStageList } from '@/api/customer.js'
export default {
  name: 'customerStage',
  data () {
    return {
      stages: [
        {
          name: '',
          class: 'initialContact',
          hide: true
        },
        {
          name: '',
          class: 'primaryClue',
          hide: true
        },
        {
          name: '',
          class: 'intentionalClue',
          hide: true
        },
        {
          name: '',
          class: 'confirmClue',
          hide: true
        },
        {
          name: '',
          class: 'transactionCustomer',
          hide: true
        }
      ]
    }
  },
  methods: {
    // 点击编辑
    initialContactClick(item) {
      item.hide = false
    },
    // 点击确定
    confirmEdit(item) {
      console.log('005')
      if (item.name.length > 20) {
        _g.toastMsg('error', '等级名称过长，请重新输入')
        return
      }
      editCustomerStage(item.name, item.id).then((res) => {
        if (res.data.code === 0) {
          item.hide = true
          this.load()
          _g.toastMsg('success', '编辑成功')
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
    },
    // 点击取消
    cancel(item) {
      item.hide = true
      this.load()
    },
    load() {
      getCustomerStageList().then((res) => {
        if (res.data.code === 0) {
          console.log(res)
          for (let i in res.data.data) {
            this.stages[i].name = res.data.data[i].name
            this.stages[i].id = res.data.data[i].id
          }
        }
      })
    }
  },
  mounted() {
  },
  created() {
    this.load()
  }
}
</script>

<style scoped>
  .top-content{
    text-align: left;
    min-height: 164px;
    background: #fff;
  }
  .top-content h4{
    font-size: 14px;
    color: #333;
    line-height: 14px;
    margin-top: 14px;
    margin-bottom: 8px;
  }
  .tip-content{
    font-size: 12px;
    color: #333;
    line-height: 18px;
    font-weight: bold;
    padding-left: 47px;
  }
  .top-content h4 img{
    margin-left: 14px;
    display: block;
    float: left;
    margin-top: -2px;
    margin-right: 4px;
    width: 16px;
    height: 16px;
  }
  .top-content ul{
    padding-left: 0;
    list-style: none;
    margin-top: 6px;
  }
  .top-content ul li{
    font-size: 12px;
    color: #999;
    line-height: 22px;
  }
  .top-content ul li i{
    margin: 9px 6px 0 0;
    display: block;
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background: #999;
    float: left;
  }
  .bottom-content{
    background: #fff;
    padding-bottom: 20px;
  }
  .bottom-content h4{
    font-size: 14px;
    color: #333;
    line-height: 14px;
    padding-top: 14px;
    text-align: left;
    margin-bottom: 8px;
  }
  .bottom-content h4 img{
    margin-left: 14px;
    display: block;
    float: left;
    margin-top: -2px;
    margin-right: 4px;
    width: 16px;
    height: 16px;
  }
  .item{
    width: 420px;
    height: 50px;
    margin: 14px 0 14px 14px;
    border-radius: 4px;
  }
  .item:first-child{
    margin-top: 0;
  }
.content {
  background-color: #F0F2F5 ;
  width: 100%;
}
.edit-btn{
  display: block;
  width: 15px;
  height: 14px;
  float: left;
  background: none;
  margin: 18px 0 0 10px;
  padding: 0;
  cursor: pointer;
}
  .save-btn{
    color: #2C8AFF;
    font-style: normal;
    font-size: 12px;
    line-height: 50px;
    float: left;
    cursor: pointer;
  }
</style>
